import React from 'react';
import { Flex } from './Container/Flex';
import { CircularProgress } from '@mui/material';

const LoadingPage = () => {
  return (
    <Flex
      style={{
        height: '100vh'
      }}
      align="center"
      justify="center"
      fullWidth>
      <CircularProgress />
    </Flex>
  )
};

export default LoadingPage;